/* import SelectStoreTab from "../../components/tabs/SelectStoreTab";
import Template from "../Template";
import DashboardFilter from "./DashboardFilter";
import "../../styles/dashboard/dashboard.css";
import DashboardCard from "./DashboardCard";
import { GiTwoCoins } from "react-icons/gi";
import { BsHandbag } from "react-icons/bs";
import { HiOutlineTicket } from "react-icons/hi";
import { TiArrowRepeat } from "react-icons/ti";
import DashboardLineChart from "../../components/charts/DashboardLineChart";
import BarChart from "../../components/charts/BarChat";
import BarChatDesktop from "../../components/charts/BarChatDesktop";
import OnlineVistorsChat from "../../components/charts/OnlineVistorsChat";
import DoughnutChart from "../../components/charts/DoughnutChart";
import DoughnutChartDB from "../../components/charts/DoughNutDashboarChart";
import GaugeConRate from "../../components/charts/GaugeConRate";
import { getDashboardUrl } from "../../api/endpoints";
import { useState, useLayoutEffect } from "react";
import Spinner from "../../components/uxCollections/Loaders";
import { useNavigate } from "react-router-dom";
import { refreshUserToken } from "../../tools/refreshToken";
import { useSelector } from "react-redux";
import { monthNameShort } from "./DailyFilter";
import LoadingSkeleton from "../../components/uxCollections/skeletonLoader/dashboard/DashboardSkeletion";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

const Dashboard = () => {
  const [filterRecordBasedOnStore, setFilterRecordBasedOnStore] = useState({ storeId: "1", storeName: "All Stores" });
  const [resetSToreFilter, setResetSToreFilter] = useState(false);
  const [disableStoreFilter, setDisableStoreFilter] = useState(false);
  const [rawData, setRawData] = useState();
  const [dashboardData, setDashboardData] = useState();
  const [dashboardDataCopy, setDashboardDataCopy] = useState();
  const [whichDashboardToRender, setWhichDashboardToRender] = useState("today"); // today || yesterday 
  const [isLoading, setIsLoading] = useState(false); //
  const { user } = useSelector((state) => state.webStoreUser);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setIsLoading(true);
    getTodayOrYesterdayDashboard();
  }, []);
  useLayoutEffect(() => {
    if (filterRecordBasedOnStore.storeId === "1") {
      console.log("this useeffect runs");

      setDashboardData(dashboardDataCopy);
      return;
    } else {
      let filteredStoreData = Object.values(rawData)[0].filter((record) => record.storeID.toString() === filterRecordBasedOnStore.storeId.toString());
      console.log(filteredStoreData, "filteredStoreData");
      let newFilteredStoreData = {
        conversionRate: filteredStoreData[0].conversionRate || 0,
        totalOrders: filteredStoreData[0].totalOrders,
        totalReturned: filteredStoreData[0].totalReturns,
        totalSales: filteredStoreData[0].totalSales,
        stockValue: filteredStoreData[0].stockValue,
        storeID: filteredStoreData[0].storeID,
        onlineVisitors: Object.values(filteredStoreData[0].onlineVisitors),
        profit: Object.values(filteredStoreData[0].profit),
        expenses: Object.values(filteredStoreData[0].expenses),
        timeLine: Object.keys(filteredStoreData[0].profit),
        cashTransaction: filteredStoreData[0].transactionType[0].amount,
        loanTransaction: filteredStoreData[0].transactionType[1].amount,
        salesOnline: Object.values(filteredStoreData[0].sales).map((record) => record[0].online),
        salesOffline: Object.values(filteredStoreData[0].sales).map((record) => record[1].inStore),
        newCustomers: filteredStoreData[0].newCustomers,
      };
      console.log(newFilteredStoreData, "newFilteredStoreData");
      setDashboardData(newFilteredStoreData);
    }
  }, [filterRecordBasedOnStore]);

  useLayoutEffect(() => {
    console.log(whichDashboardToRender, "whichDashboardToRender");

    if (whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday") {
      console.log("custom dashboard");
      setDisableStoreFilter(true);
      return;
    } else {
      setDisableStoreFilter(false);
      setResetSToreFilter(!resetSToreFilter);
      getTodayOrYesterdayDashboard();
    }
  }, [whichDashboardToRender]);

  const getTodayOrYesterdayDashboard = async () => {
    setIsLoading(true);
    try {
      console.log("getting dashboard");

      let res = await fetch(getDashboardUrl + whichDashboardToRender, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (res.ok) {
        let { rawData, reducedData } = await res.json();
        setRawData(rawData);
        setDashboardData(reducedData);
        setDashboardDataCopy(reducedData);
        console.log(reducedData, rawData);
        setIsLoading(false);
      } else if (res.status === 400) {
        refreshUserToken(getDashboardUrl + whichDashboardToRender, getTodayOrYesterdayDashboard, navigate);
      } else {
        uiAlert("dahsboard not found");
        //navigate("/sign-in");
        setIsLoading(false);
        setWhichDashboardToRender("today");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const trimDateStringtoFormat = (dateStringArray) => {
    // 2024-01-01 to jan 1 

    let trimedDateArray = dateStringArray.map((date) => {
      // Match YYYY-MM-DD exactly
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date.trim());
      if (!m) return date; // not a date; return unchanged
      if (date !== "total") {
        let dateArray = date.split("-");
        let month = dateArray[1];
        let day = dateArray[2];
       

        return `${monthNameShort[parseInt(month) - 1]}  ${day}`;
      } else {
        return date;
      }
    });

    return trimedDateArray;
  };

  const colorsArray = [
    "#E57373", // Red lighten-2
    "#F06292", // Pink lighten-2
    "#BA68C8", // Purple lighten-2
    "#9575CD", // Deep Purple lighten-2
    "#7986CB", // Indigo lighten-2
    "#64B5F6", // Blue lighten-2
    "#4FC3F7", // Light Blue lighten-2
    "#4DD0E1", // Cyan lighten-2
    "#4DB6AC", // Teal lighten-2
    "#81C784", // Green lighten-2
    "#AED581", // Light Green lighten-2
    "#DCE775", // Lime lighten-2
    "#FFF176", // Yellow lighten-2
    "#FFD54F", // Amber lighten-2
    "#FFB74D", // Orange lighten-2
    "#FF8A65", // Deep Orange lighten-2
    "#A1887F", // Brown lighten-2
    "#90A4AE", // Blue Grey lighten-2
  ];

  return (
    <>
      <Template>
        <h3 className='dashTiti48' style={{ marginBottom: "20px" }}>
          Sales Dashboard
        </h3>
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
          <div style={{ overflowX: "hidden" }}>
            <div className='customerFilter'>
              <SelectStoreTab updateSelectedStore={setFilterRecordBasedOnStore} resetFilter={resetSToreFilter} disableStoreFilter={disableStoreFilter} />

              <DashboardFilter
                dashboardTimeline={whichDashboardToRender}
                updateDateDashboardToRender={setWhichDashboardToRender}
                setDashboardData={setDashboardData}
                setRawData={setRawData}
                setIsLoading={setIsLoading}
                setDashboardDataCopy={setDashboardDataCopy}
              />
            </div>
       

            <div className='DashboardChatWrapper23'>
              <div>
             
                {dashboardData && (
                  <div className='cardWarper3994'>
                    <DashboardCard
                      data={{ title: "Total sales", amount: dashboardData.totalSales }}
                      icon={<BsHandbag color='#a08b4e' />}
                      bgColor={"#FBF5E3"}
                      currency={user.userCountryCurrencySymbol}
                    />
                    <DashboardCard
                      data={{ title: "Stock worth", amount: dashboardData.stockValue ? dashboardData.stockValue : "N/A" }}
                      icon={<GiTwoCoins color='#8F90C8' />}
                      bgColor={"#E1E5FD"}
                      currency={user.userCountryCurrencySymbol}
                    />
                    <DashboardCard
                      data={{ title: "Total orders", amount: dashboardData.totalOrders }}
                      icon={<HiOutlineTicket color='#EFB3B6' />}
                      bgColor={"#FFF0F2"}
                    />
                    <DashboardCard
                      data={{ title: "Total returned", amount: dashboardData.totalReturned }}
                      icon={<TiArrowRepeat color='#AFDDE9' />}
                      bgColor={"#E1F8FF"}
                    />
                  </div>
                )}
               
                <div className='lineChartDashDiv34'>
            
                  <div className='legendChartTol'>
                    <h5>Profit vs Expense</h5>
                    <div>
                      <div className='legend1Db legend1Db2'></div> <p>Profit</p>{" "}
                      <p>
                        ({user.userCountryCurrencySymbol} {dashboardData?.profit[dashboardData?.profit.length - 1]?.toLocaleString()} )
                      </p>
                      <div className='legend1Db'></div>
                      <p>Expense</p>
                      <p>
                        ({user.userCountryCurrencySymbol} {dashboardData?.expenses[dashboardData?.expenses.length - 1]?.toLocaleString()} )
                      </p>
                    </div>
                  </div>
                  <div className='lineChartDIvsi99'>
                    {dashboardData && (
                      <DashboardLineChart
                        label={
                          whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                            ? trimDateStringtoFormat(dashboardData.timeLine, "lineChart")
                            : dashboardData.timeLine
                        }
                        profit={dashboardData.profit}
                        expenses={dashboardData.expenses}
                        currency={user.userCountryCurrencySymbol}
                        xAxisLabel={
                          whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                            ? whichDashboardToRender.includes("Week")
                              ? " Days (days of the week)"
                              : "month of " + whichDashboardToRender.split(" ")[1]
                            : "Hours (time of the day)"
                        }
                      />
                    )}
                  </div>

                  
                </div>
                <div className='dhBarChat12ksdiv'>
                  <div className='ttsalesBarchat'>
                    <div className='legendChartTol'>
                      <h5>Total sales</h5>
                      <div style={{ marginRight: "0" }}>
                        <div style={{ backgroundColor: "#a4cc47" }} className='legend1Db'></div> <p>In-store</p>
                      
                        <div style={{ backgroundColor: "#5887DE" }} className='legend1Db legend1Db2'></div> <p>Online</p>
                       
                      </div>
                    </div>
                    <div>
                      {" "}
                      {dashboardData && (
                        <BarChatDesktop
                          label={
                            whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                              ? trimDateStringtoFormat(dashboardData.timeLine, "bar chart")
                              : dashboardData.timeLine
                          }
                          online={dashboardData.salesOnline}
                          inStore={dashboardData.salesOffline}
                          currency={user.userCountryCurrencySymbol}
                        />
                      )}
                    </div>
                  </div>
                  <div className='onlineVistitorsDash01'>
                    <div className='legendChartTol'>
                      <h5>Online visitors</h5>
                      <div style={{ marginRight: "0" }}>
                        <div style={{ backgroundColor: "#E2CCCC" }} className='legend1Db '></div> <p>current</p>
                      </div>
                    </div>
                    <div>
                      {dashboardData && (
                        <OnlineVistorsChat
                          label={
                            whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday"
                              ? trimDateStringtoFormat(dashboardData.timeLine, "online visitors")
                              : dashboardData.timeLine
                          }
                          visitors={dashboardData.onlineVisitors}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className='transactionsChartDB'>
                  <div className='legendChartTol'>
                    <h5>Transactions</h5>
                  </div>
                  <div>{dashboardData && <DoughnutChartDB transactionType={[dashboardData.cashTransaction, dashboardData.loanTransaction]} />}</div>
                  <div style={{ marginRight: "0", display: "flex", gap: "10px", justifyContent: "center", alignItems: "center", marginTop: "16px" }}>
                    <div style={{ backgroundColor: "#30A7EC" }} className='legend1Db'></div> <p>Paid</p>
                    <div style={{ backgroundColor: "rgb(204, 42, 99)" }} className='legend1Db legend1Db2'></div> <p>Amount on loan</p>
                  </div>
                </div>
                <div className='ConvervsationrateDb83'>
                  <h5>{filterRecordBasedOnStore.storeId === "1" ? "Average Productivity index" : "Productivity index"}</h5>

                  {dashboardData && <GaugeConRate conversionRate={parseInt(dashboardData.conversionRate, 10)} />}
                </div>
                <div className='dashboardinfoDiv'>
                  <h5> New Customers </h5>
                  <div
                    onClick={() => {
                      navigate("/customers");
                    }}
                    className='newCustomerDiv8376'
                    style={{ cursor: "pointer" }}
                  >
                    {dashboardData && dashboardData.newCustomers?.length > 0 ? (
                      dashboardData?.newCustomers.slice(0, 3).map((customer, index) => (
                        <div key={index} className='imagecust63hh'>
                          {" "}
                         
                          <div style={{ backgroundColor: `${colorsArray[Math.floor(Math.random() * colorsArray.length)]}` }}>
                            {customer.fullName.slice(0, 1).toUpperCase()} <br />
                          </div>
                        </div>
                      ))
                    ) : (
                      <div>
                        <p style={{ color: "rgba(241, 241, 241, 0.5)", fontSize: "0.9rem" }}>
                          {whichDashboardToRender === "today" ? "No new customer today" : "No new customer in this time"}
                        </p>
                      </div>
                    )}
                 
                    {dashboardData && dashboardData.newCustomers?.length > 3 && (
                      <div className='plusMore7354'>
                        <p>+ {dashboardData.newCustomers?.length - 3} more</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </Template>
    </>
  );
};

export default Dashboard;
 */

import { useState, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Template from "../Template";
import SelectStoreTab from "./selectStore/SelectStoreTab";
import DashboardFilter from "./DailyFilter";
import DashboardLineChart from "../../components/charts/DashboardLineChart";
import BarChatDesktop from "../../components/charts/BarChatDesktop";
import OnlineVistorsChat from "../../components/charts/OnlineVistorsChat";
import DoughnutChartDB from "../../components/charts/DoughNutDashboarChart";
import LoadingSkeleton from "../../components/uxCollections/skeletonLoader/dashboard/DashboardSkeletion";
import RecentTransactions from "./RecentTransaction";
import TransactionDetailOverlay from "./Transactiondetailoverlay";
import { getDashboardUrl } from "../../api/endpoints";
import { refreshUserToken } from "../../tools/refreshToken";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";
import { monthNameShort } from "./DailyFilter";
import "./newStyles/dashboard.css";
import GaugeConRate from "./gaugeIndex/Gaugeconrate";
import Loader from "../../components/uxCollections/storelensSpiner/StorelenseSpinner";

const Dashboard = () => {
  const [filterRecordBasedOnStore, setFilterRecordBasedOnStore] = useState({ storeId: "1", storeName: "All Stores" });
  const [resetSToreFilter, setResetSToreFilter] = useState(false);
  const [disableStoreFilter, setDisableStoreFilter] = useState(false);
  const [rawData, setRawData] = useState();
  const [transactionsInScope, setTransactionsInScope] = useState([]);
  const [dashboardData, setDashboardData] = useState();
  const [dashboardDataCopy, setDashboardDataCopy] = useState();
  const [whichDashboardToRender, setWhichDashboardToRender] = useState("today");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const { user } = useSelector((state) => state.webStoreUser);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setIsLoading(true);
    getTodayOrYesterdayDashboard();
  }, []);

  useLayoutEffect(() => {
    if (!rawData) return;
    if (filterRecordBasedOnStore.storeId === "1") {
      setDashboardData(dashboardDataCopy);
      return;
    }
    const filteredStoreData = Object.values(rawData)[0].filter((record) => record.storeID.toString() === filterRecordBasedOnStore.storeId.toString());
    const s = filteredStoreData[0];
    setDashboardData({
      conversionRate: s.conversionRate || 0,
      totalOrders: s.totalOrders,
      totalReturned: s.totalReturns,
      totalSales: s.totalSales,
      stockValue: s.stockValue,
      storeID: s.storeID,
      onlineVisitors: Object.values(s.onlineVisitors),
      profit: Object.values(s.profit),
      expenses: Object.values(s.expenses),
      timeLine: Object.keys(s.profit),
      cashTransaction: s.transactionType[0].amount,
      loanTransaction: s.transactionType[1].amount,
      salesOnline: Object.values(s.sales).map((r) => r[0].online),
      salesOffline: Object.values(s.sales).map((r) => r[1].inStore),
      newCustomers: s.newCustomers,
    });
  }, [filterRecordBasedOnStore]);

  useLayoutEffect(() => {
    if (whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday") {
      setDisableStoreFilter(true);
      return;
    }
    setDisableStoreFilter(false);
    setResetSToreFilter((p) => !p);
    getTodayOrYesterdayDashboard();
  }, [whichDashboardToRender]);

  const getTodayOrYesterdayDashboard = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(getDashboardUrl + whichDashboardToRender, {
        method: "GET",
        headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
      });
      if (res.ok) {
        const { rawData, reducedData, transactionInPeriod } = await res.json();
        setRawData(rawData);
        setDashboardData(reducedData);
        setDashboardDataCopy(reducedData);
        setTransactionsInScope(transactionInPeriod || []);
        setIsLoading(false);
      } else if (res.status === 400) {
        refreshUserToken(getDashboardUrl + whichDashboardToRender, getTodayOrYesterdayDashboard, navigate);
      } else {
        uiAlert("Dashboard not found");
        setIsLoading(false);
        setWhichDashboardToRender("today");
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const trimDateStringtoFormat = (arr) =>
    arr.map((date) => {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date.trim());
      if (!m) return date;
      const parts = date.split("-");
      return `${monthNameShort[parseInt(parts[1]) - 1]} ${parts[2]}`;
    });

  const isCustomRange = whichDashboardToRender !== "today" && whichDashboardToRender !== "yesterday";
  const chartLabels = dashboardData ? (isCustomRange ? trimDateStringtoFormat(dashboardData.timeLine) : dashboardData.timeLine) : [];
  const xAxisLabel = isCustomRange
    ? whichDashboardToRender.includes("Week")
      ? "Days of the week"
      : "Month of " + whichDashboardToRender.split(" ")[1]
    : "Hours (time of day)";

  /* ── Derived values ── */
  const cur = user.userCountryCurrencySymbol;
  const totalTxn = dashboardData ? (dashboardData.cashTransaction || 0) + (dashboardData.loanTransaction || 0) : 0;
  const paidPct = totalTxn > 0 ? Math.round((dashboardData.cashTransaction / totalTxn) * 100) : 0;
  const salesWithoutTotal = dashboardData ? dashboardData.salesOffline.slice(0, -1) : [];
  const timelineWithoutTotal = dashboardData ? dashboardData.timeLine.slice(0, -1) : [];
  const peakIdx = salesWithoutTotal.length > 0 ? salesWithoutTotal.indexOf(Math.max(...salesWithoutTotal)) : -1;
  const peakVal = peakIdx >= 0 ? salesWithoutTotal[peakIdx] : 0;
  const peakHour = peakIdx >= 0 && peakVal > 0 ? timelineWithoutTotal[peakIdx] + ":00" : "—";
  const totalProfit = dashboardData ? dashboardData.profit[dashboardData.profit.length - 1] || 0 : 0;
  const profitMargin = dashboardData && dashboardData.totalSales > 0 ? ((totalProfit / dashboardData.totalSales) * 100).toFixed(1) : "0.0";
  const newCustCount = dashboardData?.newCustomers?.length || 0;
  const firstNewCust = dashboardData?.newCustomers?.[0]?.fullName || null;

  return (
    <Template>
      {/* Transaction detail overlay */}
      {selectedTransaction && <TransactionDetailOverlay transaction={selectedTransaction} currency={cur} onClose={() => setSelectedTransaction(null)} />}

      {/*  <LoadingSkeleton /> */}
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100vh - 160px)" }}>
          <Loader size={70} />
        </div>
      ) : (
        <div className='db-root'>
          {/* Top bar */}
          <div className='db-topbar'>
            <div>
              <h3 className='db-title'>Sales Dashboard</h3>
              <p className='db-title-sub'>
                {filterRecordBasedOnStore.storeName} ·{" "}
                {whichDashboardToRender === "today" ? "Today" : whichDashboardToRender === "yesterday" ? "Yesterday" : whichDashboardToRender}
              </p>
            </div>
            <div className='db-controls'>
              <SelectStoreTab updateSelectedStore={setFilterRecordBasedOnStore} resetFilter={resetSToreFilter} disableStoreFilter={disableStoreFilter} />
              <DashboardFilter
                dashboardTimeline={whichDashboardToRender}
                updateDateDashboardToRender={setWhichDashboardToRender}
                setDashboardData={setDashboardData}
                setRawData={setRawData}
                setIsLoading={setIsLoading}
                setDashboardDataCopy={setDashboardDataCopy}
                setTransactionsInScope={setTransactionsInScope}
              />
            </div>
          </div>

          {/* KPI Strip */}
          {dashboardData && (
            <div className='db-kpi-strip'>
              <KpiCard label='Total sales' value={fmt(dashboardData.totalSales, cur)} sub='' trend='up' accent='#4A90E2' />
              <KpiCard label='Total profit' value={fmt(totalProfit, cur)} sub={`${profitMargin}% margin`} trend='up' accent='#1d9e75' highlight />
              <KpiCard label='Stock value' value={fmt(dashboardData.stockValue, cur)} sub='Across all stores' trend='neutral' accent='#7c3aed' />
              <KpiCard label='Total orders' value={String(dashboardData.totalOrders)} sub='Completed orders' trend='neutral' accent='#d85a30' />
              <KpiCard label='Returns' value={String(dashboardData.totalReturned)} sub='Items returned' trend='neutral' accent='#c0392b' />
              <KpiCard
                label='New customers'
                value={String(newCustCount)}
                sub={firstNewCust || "This period"}
                trend={newCustCount > 0 ? "up" : "neutral"}
                accent='#1d9e75'
              />
            </div>
          )}

          {/* Main grid */}
          <div className='db-main-grid'>
            {/* LEFT */}
            <div className='db-left-col'>
              <div className='db-card'>
                <div className='db-card-hd'>
                  <h4>Profit vs Expense</h4>
                  <div className='db-legend'>
                    <span>
                      <b className='db-dot' style={{ background: "#1e3a5f" }} />
                      Profit ({cur}
                      {dashboardData?.profit[dashboardData.profit.length - 1]?.toLocaleString()})
                    </span>
                    <span>
                      <b className='db-dot' style={{ background: "#f06292" }} />
                      Expense ({cur}
                      {dashboardData?.expenses[dashboardData.expenses.length - 1]?.toLocaleString()})
                    </span>
                  </div>
                </div>
                {dashboardData && (
                  <DashboardLineChart
                    label={chartLabels}
                    profit={dashboardData.profit}
                    expenses={dashboardData.expenses}
                    currency={cur}
                    xAxisLabel={xAxisLabel}
                  />
                )}
              </div>

              <div className='db-two-col'>
                <div className='db-card'>
                  <div className='db-card-hd'>
                    <h4>Total sales</h4>
                    <div className='db-legend'>
                      <span>
                        <b className='db-dot' style={{ background: "#a4cc47" }} />
                        In-store
                      </span>
                      <span>
                        <b className='db-dot' style={{ background: "#4A90E2" }} />
                        Online
                      </span>
                    </div>
                  </div>
                  {dashboardData && (
                    <BarChatDesktop label={chartLabels} online={dashboardData.salesOnline} inStore={dashboardData.salesOffline} currency={cur} />
                  )}
                </div>
                <div className='db-card'>
                  <div className='db-card-hd'>
                    <h4>Online visitors</h4>
                    <div className='db-legend'>
                      <span>
                        <b className='db-dot' style={{ background: "#e2cccc" }} />
                        Current
                      </span>
                    </div>
                  </div>
                  {dashboardData && <OnlineVistorsChat label={chartLabels} visitors={dashboardData.onlineVisitors} />}
                </div>
              </div>

              {/* Clickable recent transactions */}
              {dashboardData && (
                <RecentTransactions
                  rawData={transactionsInScope}
                  selectedStore={filterRecordBasedOnStore}
                  currency={cur}
                  onTransactionClick={(txn) => setSelectedTransaction(txn)}
                />
              )}
            </div>

            {/* RIGHT */}
            <div className='db-right-col'>
              {/* Transactions donut — thick ring, bigger border */}
              <div className='db-card db-card--txn'>
                <div className='db-card-hd'>
                  <h4>Transactions overview</h4>
                </div>
                {dashboardData?.cashTransaction || dashboardData?.loanTransaction ? (
                  <DoughnutChartDB transactionType={[dashboardData.cashTransaction, dashboardData.loanTransaction]} />
                ) : (
                  <p className='db-empty-msg'>No transactions found for this period</p>
                )}
                <div className='db-donut-legend'>
                  <span>
                    <b className='db-sq' style={{ background: "#1e3a5f" }} />
                    Paid
                  </span>
                  <span>
                    <b className='db-sq' style={{ background: "#d85a30" }} />
                    On loan
                  </span>
                </div>
                {dashboardData && (
                  <div className='db-stat-list' style={{ marginTop: 12 }}>
                    <div className='db-stat-row'>
                      <span>Paid</span>
                      <strong>
                        {cur}
                        {dashboardData?.cashTransaction?.toLocaleString()} ({paidPct}%)
                      </strong>
                    </div>
                    <div className='db-stat-row'>
                      <span>On loan</span>
                      <strong style={{ color: "#d85a30" }}>
                        {cur}
                        {dashboardData?.loanTransaction?.toLocaleString()} ({100 - paidPct}%)
                      </strong>
                    </div>
                  </div>
                )}
              </div>

              {/* Sales breakdown */}
              {dashboardData && (
                <div className='db-card'>
                  <div className='db-card-hd'>
                    <h4>Sales breakdown</h4>
                  </div>
                  <div className='db-stat-list'>
                    <div className='db-stat-row'>
                      <span>In-store total</span>
                      <strong>
                        {cur}
                        {dashboardData.salesOffline[dashboardData.salesOffline.length - 1]?.toLocaleString()}
                      </strong>
                    </div>
                    <div className='db-stat-row'>
                      <span>Online total</span>
                      <strong>
                        {cur}
                        {dashboardData.salesOnline[dashboardData.salesOnline.length - 1]?.toLocaleString()}
                      </strong>
                    </div>
                    <div className='db-stat-row'>
                      <span>Peak hour</span>
                      <strong>{peakHour}</strong>
                    </div>
                    <div className='db-stat-row'>
                      <span>Total profit</span>
                      <strong style={{ color: "#1d9e75" }}>{fmt(totalProfit, cur)}</strong>
                    </div>
                  </div>
                </div>
              )}

              <div className='db-card'>
                <div className='db-card-hd'>
                  <h4>{filterRecordBasedOnStore.storeId === "1" ? "Avg productivity index" : "Productivity index"}</h4>
                </div>
                {dashboardData && <GaugeConRate conversionRate={parseInt(dashboardData.conversionRate, 10)} />}
              </div>

              {/* New customers */}
              <div className='db-card'>
                <div className='db-card-hd'>
                  <h4>New customers</h4>
                  {newCustCount > 0 && (
                    <span className='db-see-all' onClick={() => navigate("/customers")}>
                      See all
                    </span>
                  )}
                </div>
                {dashboardData?.newCustomers?.length > 0 ? (
                  <div className='db-cust-list'>
                    {dashboardData.newCustomers.slice(0, 5).map((c, i) => (
                      <div key={i} className='db-cust-row'>
                        {c.avartar ? (
                          <img
                            src={c.avartar}
                            alt={c.fullName}
                            className='db-cust-avatar'
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        ) : (
                          <div className='db-avatar'>{c.fullName.slice(0, 1).toUpperCase()}</div>
                        )}
                        <div className='db-cust-info'>
                          <div className='db-cust-name'>
                            {c.fullName}
                            {c.isNewCustomer && <span className='db-new-badge'>New</span>}
                          </div>
                          <div className='db-cust-meta'>
                            {c.storepurchasedFrom?.storeName} · {c.purchaseChannel === "inStore" ? "In-store" : "Online"}
                          </div>
                        </div>
                        <div className='db-cust-amt'>{fmt(c.totalPurchaseAmount, cur)}</div>
                      </div>
                    ))}
                    {newCustCount > 5 && <div className='db-more-customers'>+{newCustCount - 5} more</div>}
                  </div>
                ) : (
                  <p className='db-empty-msg'>{whichDashboardToRender === "today" ? "No new customers today" : "No new customers in this period"}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Template>
  );
};

/* ── KPI Card ── */
const KpiCard = ({ label, value, sub, trend, accent = "#4A90E2", highlight = false }) => (
  <div className={`db-kpi-card${highlight ? " db-kpi-card--highlight" : ""}`} style={highlight ? { borderLeft: `3px solid ${accent}` } : {}}>
    <div className='db-kpi-label'>{label}</div>
    <div className='db-kpi-value' style={highlight ? { color: accent } : {}}>
      {value}
    </div>
    <div className={`db-kpi-sub db-kpi-sub--${trend}`}>
      {trend === "up" && "↑ "}
      {trend === "down" && "↓ "}
      {sub}
    </div>
  </div>
);

/* ── Format helper ── */
function fmt(v, symbol = "") {
  if (!v && v !== 0) return "N/A";
  if (v >= 1e9) return symbol + (v / 1e9).toFixed(2) + "B";
  if (v >= 1e6) return symbol + (v / 1e6).toFixed(2) + "M";
  if (v >= 1e3) return symbol + (v / 1e3).toFixed(1) + "K";
  return symbol + v.toLocaleString();
}

export default Dashboard;
